import React from 'react';
import { useFormikContext } from 'formik';
import { Button, ButtonProps } from '@mui/material';
import useTranslate from '../../../../Hooks/useTranslate';

interface Props extends ButtonProps {
  loading?: boolean;
}

function SubmitButton({ title, loading, disabled, ...rest }: Props) {
  const { dirty, isValid } = useFormikContext();
  const ts = useTranslate();
  const content = loading ? ts('common.action.loading') : title;

  return (
    <Button
      // disabled must stay last-computed here; spreading rest before it would let a caller's
      // own `disabled` prop silently override the form validity check.
      disabled={(dirty ? !isValid : true) || loading || disabled}
      aria-label="submit"
      variant="contained"
      color="primary"
      type="submit"
      children={content}
      {...rest}
    />
  );
}

export default SubmitButton;
